import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Label = styled.label`
	color: var(--shade-shade-60, #727780);
	font-family: Public Sans;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px; /* 171.429% */
	margin-left: 15px;
	display: flex;
	align-items: start;
	justify-content: flex-start;
	flex-direction: column;
`

const Select = styled.select`
	display: flex;
	padding: 0px 16px;
	align-items: center;
	gap: 10px;
	align-self: stretch;
	border-radius: 20px;
	border: 1px solid #DDD;
	background: #F0F1F2;
	height: 44px;
`

class InputBookSelect extends React.Component {
	static propTypes = {
		width: PropTypes.string.isRequired,
		placeholder: PropTypes.string.isRequired,
		spanText: PropTypes.string,
		options: PropTypes.array,
		value: PropTypes.string,
		field: PropTypes.string,
		handleGeneralChange: PropTypes.func,
		handleSelectedArea: PropTypes.func,
	};

	render() {
		const {
			width,
			placeholder,
			spanText,
			options,
			handleGeneralChange,
			value,
			field,
			handleSelectedArea
		} = this.props;

		return (
			<Label>{spanText}
				<Select
					style={{ width: `${width}` }}
					onChange={(e) => (handleGeneralChange(field, e.target.value), (
						handleSelectedArea && handleSelectedArea(e)))}
					value={value}
				>
					<option value="" disabled selected>{placeholder}</option>
					{options.map((opt) => (
						<option value={opt.value}>{opt.label}</option>
					))}
				</Select>
			</Label>
		);
	}
}

export default InputBookSelect;
